var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 -3.0598e-07L12 5L12 15C12 15.5523 11.5523 16 11 16L1 16C0.447715 16 -1.95703e-08 15.5523 -4.37114e-08 15L-6.55671e-07 1C-6.79812e-07 0.447715 0.447715 -1.95703e-08 0.999999 -4.37114e-08L7 -3.0598e-07ZM2 2L2 14L10 14L10 7L6.5 7C5.67157 7 5 6.32843 5 5.5L5 2L2 2ZM7 2.82843L7 5L9.17157 5L7 2.82843Z",
    fill: "#44BDD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.3e37116bfd6b93c2302e73be815ec453.svg";
export { ForwardRef as ReactComponent };